import { createContext } from 'react'

export const UserPreferencesContext = createContext({
  userPreferences: {},
  setUserPreferences: () => {},
})
